import { BadgeContainer } from './styles';

interface CustomBadgeProps {
  label: string | number;
}
export const CustomBadge = ({ label }: CustomBadgeProps) => {
  return <BadgeContainer>{label}</BadgeContainer>;
};
